import React, { useContext } from "react";
import PropTypes from "prop-types";
import UserPrefsContext from "../../../context/UserPrefs/UserPrefsContext";

import { FormatAsThousands } from "../../../utils/Helpers/Format";

import Range from "../../shared/InputElements/Range";
import { useIntl } from 'react-intl';

const SlideRange = ({
  id = "miles-range",
  label = "Range",
  ...rest
}) => {
  const intl = useIntl();
  const userPrefs = useContext(UserPrefsContext);

  const descriptionFn = val => {
    return `> ${FormatAsThousands(val)} ${intl.formatMessage ? (process.env.REACT_APP_METRIC_SYSTEM ? intl.formatMessage({ id: "vehicle.kilometersCapital", defaultMessage: "kilometers" }) : intl.formatMessage({ id: "vehicle.milesCapital", defaultMessage: "miles" })) : "miles"}`;
  };

  return (
    <Range
      id={id}
      value={userPrefs.get("vehicleRange")}
      label={label}
      rangeMin={10}
      rangeMax={550}
      rangeStep={1}
      description={descriptionFn}
      ariaControls="electric-vehicles-catalog"
      handler={e => userPrefs.set({ vehicleRange: e.target.value })}
      {...rest}
    />
  );
};

export default SlideRange;

SlideRange.propTypes = {
  id: PropTypes.string,
  label: PropTypes.string,
  description: PropTypes.func
};
